import { State } from "src/state";

export const getEntityListState = (state: State) => state.entityList;

export const getEntityListPage = (state: State) => {
  return (state.entityList && state.entityList.currentPage) || 0;
};



// WEBPACK FOOTER //
// ./src/entityList/selector.ts